import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

function BankTransferModal({ show, onHide }) {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Bank Transfer Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="p-3">
          
          <p className="mb-3">
            <strong>To make a donation directly via bank transfer, please use the account details below:</strong>
          </p>

          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <div className="bg-light p-3 rounded">
                <h6 className="text-primary mb-2">UK DONATIONS:</h6>
                <p className="mb-1"><strong>BANK NAME:</strong> Co-Operative Bank</p>
                <p className="mb-1"><strong>ACCOUNT NAME:</strong> Help Yateem</p>
                <p className="mb-1"><strong>ACCOUNT No:</strong> 67324703</p>
                <p className="mb-0"><strong>SORT CODE:</strong> 08-92-99</p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="bg-light p-3 rounded">
                <h6 className="text-primary mb-2">INTERNATIONAL DONATIONS:</h6>
                <p className="mb-1"><strong>IBAN:</strong> GB18MYMB 230580 44148773</p>
                <p className="mb-0"><strong>SWIFT/BIC:</strong> MYMBGB2L</p>
              </div>
            </div>
          </div>

          <p className="mb-3"><strong>JazakhaAllahu Khairan for your continuous support.</strong></p>
          
          <p className="mb-0">
            Please label your donations clearly with your name and any particular cause you would like your donation to be used for and please notify us when you have made your donation by emailing us at{' '}
            <a href="mailto:info@helpyateem.org">info@helpyateem.org</a>
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

BankTransferModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
};

export { BankTransferModal }; 